import React, { useState } from 'react'
import './profile.css'
import profileimg from '../../Assets/User_2.svg'
import logout from '../../Assets/Logout.svg'
import { Navigate, useNavigate } from 'react-router-dom'


const ProfileCard = () => {
    const navigate=useNavigate()
    const [userdata,setuserdata]=useState(JSON.parse(localStorage.getItem("userData")))
    const [uname, setuname] = useState(userdata.User_Name)
    const [role, setrole] = useState(userdata.Roles)
    // console.log(uname, pass);
    const closeid=()=>{
        localStorage.clear();
        navigate("/")
        window.location.reload();
    }
    return (
        <div className='profile-div'>
            {/* <div className='row'><div className="col text-end"><img src={} alt="close" /></div></div> */}
            <div className='row p-3 pt-4 justify-content-center'> <div className='text-center col'><img src={profileimg} style={{width:"100px"}} className='rounded-pill' alt="profilepic" /></div> </div>
            <div className='row mt-4 justify-content-center' style={{ whiteSpace: "nowrap" }}><div className="col text-center"><h5>Username : {uname}</h5></div></div>
            <div className='row justify-content-center' style={{ whiteSpace: "nowrap" }}><div className="col text-center"><h5>role : {role}</h5></div></div>
            <div className='row justify-content-center mt-4'>
               <div className='text-center col align-items-center'> 
               <button style={{whiteSpace:"nowrap"}} className='bg-btn text-white px-4 rounded-5  py-1 fs-5' onClick={closeid}>Logout <img src={logout} height={25} className='ps-2' alt="logout" /></button>
               </div>
            </div>
        </div>
    )
}

export default ProfileCard